import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const CREDENTIAL_ENCRYPTION_SETTINGS_PREFIX = 'credential-encryption-settings';

export const GridRowHeight = 44;

export const credentialEncryptionSpaceContainer = cssClass(CREDENTIAL_ENCRYPTION_SETTINGS_PREFIX, 'space', {
  display: 'block',
});


export const credentialEncryptionSettingsContainer = cssClass(CREDENTIAL_ENCRYPTION_SETTINGS_PREFIX, 'container', {
  paddingBottom: CommonStyles.Sizes.XLargeSpace,
});


export const tableStyle: React.CSSProperties = {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  };

  export const cellStyle: React.CSSProperties = {
    padding: '10px',
    paddingLeft: '0px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd',
  };


  export const headerStyle: React.CSSProperties = {
    fontWeight: 'bold',
    fontSize: '12px',
    borderBottom: '1px solid #ddd'
  };

  export const rowStyle: React.CSSProperties = {
    height: '44px'
  };


  export const tooltipCellStyle: React.CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  export const ProgressBarBackgroundFill: React.CSSProperties = {
    backgroundColor:'#C9C9C9',
    display: 'inline-block',
    height: '5px',
    borderRadius: '4px',
    width: '100%',
    marginBottom: '5px',
  };

  export const ProgressBarForegroundFill: React.CSSProperties =  {
    height: '5px',
    backgroundColor: '#05628A',
    borderRadius: '4px',
    color: 'white',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box',
  };
